import { TrackingEventName } from 'services/tracking/constants';
import { automationTasksTrackingEventMapper } from 'services/candidate/utils/automationTrackingEventMapper';
import { AutomationTaskActions } from './formatAutomationTasksForSubmission';

type HandleAnalyseAutomationTrackingProps = {
  automationTasksActions: AutomationTaskActions;
  track: (eventName: string, properties?: Record<string, any>) => void;
};

export const handleAnalyseAutomationTracking = ({
  automationTasksActions,
  track
}: HandleAnalyseAutomationTrackingProps) => {
  const {
    automationTasksToDelete,
    automationTasksToUpdate,
    automationTasksToCreate
  } = automationTasksActions;
  track(TrackingEventName.AnalyseEditRules, {
    automationTasksDelete: !!automationTasksToDelete?.length,
    automationTasksUpdate: !!automationTasksToUpdate.length,
    automationTasksCreate: !!automationTasksToCreate.length,
    ...automationTasksTrackingEventMapper(automationTasksToCreate)
  });
};
